import * as React from 'react'
import { withRouter } from 'react-router-dom';
import glamorous from 'glamorous'

import { debounce, noop } from 'lodash'
import { $ } from 'utils'
import { Icon, Loader } from 'components'
import { SEARCH } from 'queries'
import { client } from 'config'

const SearchContainer = glamorous.div({
  flex: 1,
  padding: 10,
  textAlign: 'center',
  backgroundColor: 'white',
})

const SearchBgContainer = glamorous.div({
  padding: '0 10px',
  borderRadius: 3,
})

const SearchInner = glamorous.div({
  display: 'inline-flex',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  height: 30,
  transition: 'width 200ms',
})

const InputContainer = glamorous.div({
  position: 'relative',
  width: '100%',
  height: '100%',
})

const Input = glamorous.input({
  display: 'inline-block',
  position: 'absolute',
  height: '100%',
  width: '100%',
  left: 0,
  top: 0,
  borderRadius: 3,
  textAlign: 'left',
  border: 'none',
  boxShadow: 'none',
  paddingLeft: 10,
  '&': {
    outline: 'none !important',
    boxShadow: 'none !important'
  }
})

const routes = {
  'Person': 'persons',
  'Descriptor': 'faces'
}

class Search extends React.Component {

  static defaultProps = {
    onChange: noop,
  }

  state = {
    value: '',
  };

  componentWillMount() {
    const decodedUri = decodeURI(this.props.location.pathname)
    if (decodedUri.includes('search')) {
      const splittedPath = decodedUri.split('/')
      this.setState({ value: splittedPath[2] })
    }
  }

  

  handleChange = e =>
    this.setState({ value: e.target.value, loading: !!e.target.value }, this.update)

  update = debounce(() => {
    if (this.state.value) {
      this.query()
    }
  }, 500)

  query = () =>
    client.query({
      query: SEARCH,
      fetchPolicy: 'network-only',
      variables: { query: this.state.value }
    }).then(({ data }) => {
      this.setState({ loading: false })
      if (data.search.items) {
        this.props.push(`/search/${this.state.value}`)
      } else if (data.search.__typename) {
        this.props.push(`/${routes[data.search.__typename]}/${data.search.uuid}`)
        this.setState({value: ''})
      }
    })

  handleKeyPress = () =>
    this.state.value &&
      this.query()

  render = () =>
    $(SearchContainer,
      $(SearchBgContainer,
        $(SearchInner,
          this.state.loading
            ? $(Loader, { size: 28, style: { width: 'auto', marginRight: -2 } })
            : $(Icon, {type: 'search', isHoverable: false}),
          $(InputContainer,
            $(Input, {
              value: this.state.value,
              type: 'text',
              placeholder: 'Search by UUID',
              onClick: this.handleKeyPress,
              onChange: this.handleChange,
            }),
          )
        )
      )
    )
}

export default withRouter(Search)



// WEBPACK FOOTER //
// ./src/pages/MainLayout/Search.js